
export const statesByAbbr = [
    { key: "AL", label: "Alabama", badge: null },
    { key: "AK", label: "Alaska", badge: null },
    { key: "AZ", label: "Arizona", badge: null },
    { key: "AR", label: "Arkansas", badge: null },
    { key: "CA", label: "California", badge: null },
    { key: "CO", label: "Colorado", badge: null },
    { key: "CT", label: "Connecticut", badge: null },
    { key: "DE", label: "Delaware", badge: null },
    { key: "FL", label: "Florida", badge: null },
    { key: "GA", label: "Georgia", badge: null },
    { key: "HI", label: "Hawaii", badge: null },
    { key: "ID", label: "Idaho", badge: null },
    { key: "IL", label: "Illinois", badge: null },
    { key: "IN", label: "Indiana", badge: null },
    { key: "IA", label: "Iowa", badge: null },
    { key: "KS", label: "Kansas", badge: null },
    { key: "KY", label: "Kentucky", badge: null },
    { key: "LA", label: "Louisiana", badge: null },
    { key: "ME", label: "Maine", badge: null },
    { key: "MD", label: "Maryland", badge: null },
    { key: "MA", label: "Massachusetts", badge: null },
    { key: "MI", label: "Michigan", badge: null },
    { key: "MN", label: "Minnesota", badge: null },
    { key: "MS", label: "Mississippi", badge: null },
    { key: "MO", label: "Missouri", badge: null },
    { key: "MT", label: "Montana", badge: null },
    { key: "NE", label: "Nebraska", badge: null },
    { key: "NV", label: "Nevada", badge: null },
    { key: "NH", label: "New Hampshire", badge: null },
    { key: "NJ", label: "New Jersey", badge: null },
    { key: "NM", label: "New Mexico", badge: null },
    { key: "NY", label: "New York", badge: null },
    { key: "NC", label: "North Carolina", badge: null },
    { key: "ND", label: "North Dakota", badge: null },
    { key: "OH", label: "Ohio", badge: null },
    { key: "OK", label: "Oklahoma", badge: null },
    { key: "OR", label: "Oregon", badge: null },
    { key: "PA", label: "Pennsylvania", badge: null },
    { key: "RI", label: "Rhode Island", badge: null },
    { key: "SC", label: "South Carolina", badge: null },
    { key: "SD", label: "South Dakota", badge: null },
    { key: "TN", label: "Tennessee", badge: null },
    { key: "TX", label: "Texas", badge: null },
    { key: "VI", label: "U.S. Virgin Islands", badge: null },
    { key: "UT", label: "Utah", badge: null },
    { key: "VT", label: "Vermont", badge: null },
    { key: "VA", label: "Virginia", badge: null },
    { key: "WA", label: "Washington", badge: null },
    { key: "WV", label: "West Virginia", badge: null },
    { key: "WI", label: "Wisconsin", badge: null },
    { key: "WY", label: "Wyoming", badge: null }
]



// WEBPACK FOOTER //
// ./src/utilities/states.js